import { AbstractProviderConfig } from '../Tc.Module.TemplatingContainer';

export interface FallbackProviderConfig extends AbstractProviderConfig {
	type : 'fallback';
	value : string;
}

export async function fallbackProvider(config : FallbackProviderConfig) {
	return config.value;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/personalization/templating/providers/fallback.ts